import dayjs from "dayjs";
import Terms20250314 from "./v20250314";
import Terms20260601 from "./v20260601";

// 통합 이용약관
const Terms = () => {
  const isChangeTerms = dayjs().isAfter("2026-06-01", "day"); // 6월1일 기준 이후면 변경

  return (
    <>
      {isChangeTerms ? <Terms20260601 /> : <Terms20250314 />}
    </>
  );
};
export default Terms;
